<template>
  <el-dialog
    class="modal-modify-user"
    :title="title"
    :visible.sync="visible"
    @close="$_cancle"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    custom-class="greater"
    lock-scroll
    append-to-body
  >
    <div class="content" v-loading="isLoading">
      <div class="content-wrap">
        <el-form
          ref="userForm"
          :rules="rules"
          label-position="top"
          :model="formData"
          class="user-modify__form"
        >
          <el-form-item label="登录账号:" prop="accountName">
            <el-input
              :disabled="formType === 'edit'"
              v-model="formData.accountName"
              placeholder="必填"
              class="form-item__input"
            ></el-input>
            <el-button v-if="formType === 'edit'" @click="$_resetPwd" class="reset-pwd__btn">重置密码</el-button>
            <div v-show="formType !== 'edit'" class="input-tips">*支持输入16个以内的字母或数字, 成功后不可修改</div>
          </el-form-item>

          <el-form-item label="用户名称:" prop="userName">
            <el-input v-model="formData.userName" placeholder="必填" class="form-item__input"></el-input>
            <div class="input-tips">*支持输入16个字符以内的中英文、数字</div>
          </el-form-item>

          <el-form-item label="登录邮箱:" prop="email">
            <el-input v-model="formData.email" placeholder="必填" class="form-item__input"></el-input>
            <div class="input-tip">*邮箱格式如 help@can-dao.com, 用于接收账号密码；<br>已开通OAC系统的账户，修改邮箱后需重新配置权限；</div>
          </el-form-item>

          <el-form-item label="账号类型:" prop="type">
            <el-select v-model="formData.type" style="width: 110px" class="area-code__selector"  :disabled="formType === 'edit'">
              <el-option
                v-for="item in formData.userTypes"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item v-if="formType==='edit' && formData.phone !== ''" label="登录手机:">
            <el-select v-model="formData.areaCode" disabled class="area-code__selector">
              <el-option label="+86" value="86"></el-option>
            </el-select>
            <el-input v-model="formData.phone" disabled placeholder="必填" class="form-item__input"></el-input>
          </el-form-item>

          <el-form-item label="账号所属系统:">
            <div class="systems-config">
              <table class="systems-config__table">
                <thead>
                  <tr>
                    <th width="240">系统名称</th>
                    <th>操作项目</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(config, index) in formData.userSysConfigList" :key="config.systemId">
                    <td>{{config.systemName}}</td>
                    <td>
                      <el-button
                        @click.stop="$_showConfig(config)"
                        :class="[
												{'has-config__btn':config.platformBrandShopInfoList.length > 0},
												{'not-config__btn': config.platformBrandShopInfoList.length === 0}
											]"
                      >{{config.platformBrandShopInfoList.length > 0 ? '已配置': '未配置'}}</el-button>

                      <el-button
                        v-if="config.platformBrandShopInfoList.length > 0"
                        @click="$_emptydisposi(index)"
                        class="clear-config__btn"
                      >清空配置</el-button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="input-tips">*默认为未配置，账号需配置系统对应的数据权限、角色权限</div>
          </el-form-item>

          <el-form-item label="第三方应用系统:" class="margin_cls">
            <div class="systems-config">
              <table class="systems-config__table">
                <thead>
                  <tr>
                    <th width="240">系统名称</th>
                    <th>操作项目</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in formData.thirdAppAccountList" :key="item.appId">
                    <td>{{item.appName}}</td>
                    <td>
                      <!-- 如果没有 bindStatus 字段则显示获取账号，否则显示点击获取账号按钮后返回的状态 -->
                      <el-button class="has-bindStatus__btn" @click="$_getAccountStatus(item.appId)" v-if="item.bindStatus === undefined && formType === 'edit'">获取账号</el-button>
                      <div v-else style="height: 30px; line-height: 30px;">
                        <el-checkbox v-model="item.bindStatus" :false-label='0' :true-label='1' v-if="item.uiType === 1 ">开通<span style="color: #F86D38;">（若勾选开通，请在备注输入数据权限说明）</span></el-checkbox>
                        <el-button class="not-bindStatus__btn" v-else-if="formType === 'add'" :disabled="true">未绑定账号</el-button>
                        <el-button
                          v-else
                          :class="[
                          {'has-bindStatus__btn': !isDisabledBindStatus(item.bindStatus)},
                          {'not-bindStatus__btn': isDisabledBindStatus(item.bindStatus)}
                        ]"
                          :disabled="isDisabledBindStatus(item.bindStatus)"
                          @click.stop="$_showApplication(item.appId)"
                        >{{item.bindMsg}}</el-button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </el-form-item>

          <el-form-item label="备注:" prop="memo">
            <el-input
              type="textarea"
              style="width: 500px; height: 48px;"
              resize="none"
              maxlength="50"
              placeholder="选填, 可填入50个字符"
              v-model="formData.memo"
            ></el-input>
            <div class="input-tipsmore">*最多支持50个字符</div>
          </el-form-item>

          <el-form-item class="status__item" label="状态:">
            <el-radio-group v-model="formData.status" style="margin-top: 6px;">
              <el-radio :label="1">启用</el-radio>
              <el-radio :label="2">停用</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <div class="edit__btns">
        <el-button class="save__btn" @click="$_submit">保存</el-button>
        <el-button class="cancel__btn" @click="$_cancle">取消</el-button>
      </div>
    </div>

    <!-- S 系统 不需要 配置数据权限 -->
    <config-global
      v-if="modal.show === true && modal.template ==='config-global'"
      :title="modal.title"
      :systemId="modal.data.systemId"
      :platformDataList="modal.data.platformDataList"
      @submit="$_callback"
      @close="$_close"
    ></config-global>
    <!-- E 系统 不需要 配置数据权限 -->

    <!-- S 系统 需要 配置数据权限 -->
    <config-assigned
      v-if="modal.show === true && modal.template ==='config-assigned'"
      :title="modal.title"
      :systemId="modal.data.systemId"
      :platformDataList="modal.data.platformDataList"
      @submit="$_callback"
      @close="$_close"
    ></config-assigned>
    <!-- E 系统 需要 配置数据权限 -->

    <!-- 账号列表 -->
    <config-accountlist
      v-if="modal.show && modal.template === 'config-accountlist'"
      :title="modal.title"
      :formType="modal.type"
      :userData="modal.data"
      @callback="$_callback"
      @close="$_close"
    ></config-accountlist>
  </el-dialog>
</template>
<script>
import * as Utils from "@/plugins/utils";
import ConfigGlobal from "./modal-config-global"; // 不需要配置数据权限
import ConfigAssigned from "./modal-config-assigned"; // 需要配置数据权限
import ConfigAccountlist from "./modal-config-accountlist"; // 账号列表

export default {
  name: "modal-modify-user",
  props: {
    title: { type: String, default: "" },
    formType: { type: String, default: "add" },
    userData: { type: Object, default: {} }
  },
  data() {
    return {
      visible: false,
      isLoading: true,
      isSubmitting: false,
      systemList: [],
      formData: {
        uid: -1,
        accountName: "", // 登录账号
        userName: "",
        email: "",
        areaCode: "86",
        phone: "",
        memo: "",
        status: 1,
        userSysConfigList: [],
        thirdAppAccountList: [],
        type: 0,
        userTypes: [
          { value: 1, label: "内部账号" },
          { value: 0, label: "外部账号" },
        ]
      },
      ApplicationConfigList: [],
      rules: {
        accountName: [
          { required: true, message: "请输入登录账号!" },
          {
            validator: (rule, value, callback) => {
              const reg = /^[a-zA-Z0-9]{1,16}$/i;
              if (value.match(reg) == null) {
                callback(new Error("请输入16个以内字母或数字!"));
              } else {
                callback();
              }
            },
            trigger: "blur"
          },
          { validator: Utils.validCharmap, trigger: "blur" }
        ],
        type: [
          { required: true, type: 'number', message: "请输入登录账号!" },
        ],
        userName: [
          { required: true, message: "请输入用户名称!" },
          {
            validator: (rule, value, callback) => {
              if (value.length > 16) {
                callback(new Error("最多为16个字符!"));
              } else if (value.match(/^[\u4e00-\u9fa5A-Za-z\d]+$/) == null) {
                callback(new Error("只支持中文、英文或数字"));
              } else {
                callback();
              }
            },
            trigger: "blur"
          },
          { validator: Utils.validCharmap, trigger: "blur" }
        ],
        email: [
          { required: true, message: "请输入邮箱地址!", trigger: "blur" },
          { type: "email", message: "邮箱格式不正确!", trigger: "blur" }
        ],
        memo: [
          {
            validator: (rule, value, callback) => {
              if (value !== "" && value.length > 50) {
                callback(new Error("最多50个字符!"));
              } else {
                callback();
              }
            },
            trigger: "blur"
          }
        ]
      },
      modal: {
        show: false,
        title: "",
        template: "",
        data: {}
      }
    };
  },
  methods: {
    isDisabledBindStatus(bindStatus) {
      // 是否已经绑定， 0:未绑定 1:已绑定 2:请求异常 3:配置错误
      return bindStatus === 0 || bindStatus === 2 || bindStatus === 3
    },
    $_getAccountStatus(appId) {
      const params = {
        appId,
        uid: this.userData.uid
      }
      this.$service.post('getThirdAppAccountStatus', params).then(result => {
        if(result.$.checkResult(result, true)) {
          this.formData.thirdAppAccountList = this.formData.thirdAppAccountList.reduce((acc,cur) => {
            // 匹配接口返回的数据与 thirdAppAccountList 数组中的item，匹配到则将返回的数据插入，否则插入原来的数据
            acc.push( cur.appId === result.data?.appId ? result.data : cur )
            return acc
          },[])
        }
      })
    },
    //三方应用系统列表
    $_showApplication(appId) {
      this.userData.appId = appId;
      this.modal.type = "";
      this.modal.data = this.userData;
      this.modal.title = "账号列表";
      this.modal.template = "config-accountlist";
      this.modal.show = true;
    },
    //清空配置
    $_emptydisposi(index) {
      const SELF = this;
      let content = `是否清空已配置的数据？清空后账号将无法使用对应的系统。请谨慎操作！
      `;
      $MessageBox.confirm({
        content,
        onOk() {
          SELF.formData.userSysConfigList[index].platformBrandShopInfoList = [];
        }
      });
    },
    /**
     * 配置 回调
     */
    $_callback(data) {
      let { systemId, platformDataList } = data;

      let index = this.formData.userSysConfigList.findIndex(
        item => item.systemId === systemId
      );
      if (~index) {
        let arr = [];
        platformDataList.map(ele => {
          arr.push({
            platformKey: ele.platformKey,
            platformName: ele.platformName,
            platformOrgType: ele.platformOrgType,
            bindRoleId: ele.bindRoleId,
            roleName: ele.roleName,
            userBrandShopInfoList: ele.brandList,
            brandIdList: ele.brandIdList,
            storeIdList: ele.storeIdList,
            orgInfoList: ele.orgInfoList,
            orgShopList: ele.orgShopList,
            fromTypeList: ele.fromTypeList,
          });
        });
        this.formData.userSysConfigList[index].platformBrandShopInfoList = [
          ...arr
        ];
      }
      this.$_close();
    },
    // 关闭此组件发起的弹窗
    $_close() {
      this.modal.show = false;
      this.modal.template = "";
      this.modal.data = {};
      this.modal.title = "";
    },
    // 配置
    $_showConfig(system) {
      this.modal.title = "配置账号所属系统";
      // 是否需要配置数据权限 是否需要配置 1是，0否
      if (system.needConfig === 1) {
        this.modal.template = "config-assigned";
      } else {
        this.modal.template = "config-global";
      }
      this.modal.data = {
        systemId: system.systemId,
        platformDataList: system.platformBrandShopInfoList.slice()
      };
      this.modal.show = true;
    },
    // 保存
    $_submit() {
      if (this.isSubmitting === true) return false;
      this.isSubmitting = true;
      setTimeout(() => {
        this.isSubmitting = false;
      }, 300);
      this.isLoading = true;
      const self = this;
      this.$refs["userForm"].validate(valid => {
        if (valid) {
          let userSysConfigList = [];
          self.formData.userSysConfigList.forEach(config => {
            let platformDataList = [];
            if (config.needConfig === 1) {
              platformDataList = config.platformBrandShopInfoList.map(item => {
                let obj = {
                  platformKey: item.platformKey,
                  bindRoleId: item.bindRoleId,
                  fromTypeList: item.fromTypeList
                };
                if (item.platformOrgType === 0) {
                  // 默认组织
                  Object.assign(obj, {
                    // brandIdList: item.brandIdList,
                    // storeIds: item.storeIdList,
                    brandStoreInfos: item.userBrandShopInfoList.map(ele => {
                      ele.storeIds = ele.shopInfos.map(obj => obj.shopId);
                      return ele;
                    })
                  });
                } else if (item.platformOrgType === 1) {
                  let orgIdList = [], orgShopIdList = [];
                  if (Array.isArray(item.orgInfoList)) {
                    orgIdList = item.orgInfoList.reduce(
                      (prev, curr) => prev.concat([curr.orgId]),
                      []
                    );
                  }
                  if (Array.isArray(item.orgShopList)) {
                    orgShopIdList = item.orgShopList.reduce(
                      (prev, curr) => prev.concat([curr.shopId]),
                      []
                    );
                  }
                  // 自定义组织
                  Object.assign(obj, {
                    orgIdList,
                    orgShopIdList
                  });
                }
                return { ...obj };
              });
            } else {
              platformDataList = config.platformBrandShopInfoList.map(item => {
                return {
                  platformKey: item.platformKey,
                  bindRoleId: item.bindRoleId
                };
              });
            }
            userSysConfigList.push({
              systemId: config.systemId,
              platformDataList
            });
          });
          let thirdAppAccountList = [];
          self.formData.thirdAppAccountList.forEach(item => {
            thirdAppAccountList.push({
              appId: item.appId,
              bindStatus: item.bindStatus,
              thirdCode: item.thirdCode,
              uiType: item.uiType,
              appName: item.appName
            })
          })
          let action = "addUser";
          let postData = {
            userName: this.formData.userName,
            email: this.formData.email,
            memo: this.formData.memo,
            status: this.formData.status,
            type: this.formData.type,
            userSysConfigList,
            thirdAppAccountList
          };
          if (this.formType === "add") {
            Object.assign(postData, { accountName: this.formData.accountName });
          } else if (this.formType === "edit") {
            action = "editUser";
            Object.assign(postData, { uid: this.formData.uid });
          }
          // return;
          self.$service.post(action, postData).then(result => {
            self.isLoading = false;
            if (result.$.checkResult(result, true)) {
              $MessageBox.alert({
                content: result.msg,
                onOk() {
                  self.$emit("callback");
                  self.visible = false;
                }
              });
            }
          });
        } else {
          this.isLoading = false;
        }
      });
    },
    // 重置密码
    $_resetPwd() {
      const self = this;
      $MessageBox.confirm({
        content: `
          <div>确定重置密码?</div>
          <div>重置后新密码将发送到您的邮箱</div>
        `,
        onOk() {
          self.$service
            .post("resetUserPwd", {
              uid: self.formData.uid
            })
            .then(result => {
              $MessageBox.alert({ content: result.msg });
            });
        }
      });
    },
    $_cancle() {
      this.visible = false;
      this.$emit("close");
    }
  },
  components: {
    ConfigGlobal,
    ConfigAssigned,
    ConfigAccountlist
  },
  async created() {
    let result = await this.$service.post("getAppSysConfigs", {
      pageNow: 1,
      pageSize: 999
    });

    this.isLoading = false;
    if (result.$.checkResult(result, true)) {
      let systemList = [];
      result.data.rows.forEach(item => {
        if (systemList.every(s => s.cid !== item.cid)) {
          systemList.push({ ...item });
        }
      });
      this.systemList = [...systemList];
    } else {
      this.systemList.splice(0);
    }

    let userSysConfigList = [];
    if (this.formType === "edit" && Object.keys(this.userData).length > 0) {
      let {
        uid,
        accountName,
        userName,
        email,
        phone,
        memo,
        type,
        status
      } = this.userData;
      this.formData.uid = uid;
      this.formData.type = type;
      this.formData.accountName = accountName;
      this.formData.userName = userName;
      this.formData.email = email;
      this.formData.phone = phone;
      this.formData.memo = memo ? memo : '';
      this.formData.status = status;
      userSysConfigList = [...this.userData.userSysConfigList];
    }
    this.systemList.forEach(item => {
      if (userSysConfigList.every(c => c.systemId !== item.cid)) {
        userSysConfigList.push({
          systemId: item.cid,
          systemName: item.systemName,
          needConfig: item.needConfig,
          platformBrandShopInfoList: []
        });
      }
    });

    this.formData.userSysConfigList = [...userSysConfigList];
  },
  async mounted() {
    this.visible = true;
    // 获取第三方应用列表
    await this.$service
      .post("thirdAppBasicInfoList", {
        uid: this.userData.uid
      })
      .then(result => {
        if (result.$.checkResult(result, true)) {
          if (result.data.length > 0) {
            this.formData.thirdAppAccountList = result.data.concat([]);
          }
        }
      });
  }
};
</script>

<style lang="scss" scoped>
.content {
  height: 100%;
  padding: {
    left: 30px;
    top: 24px;
  }
  overflow: hidden;
  &-wrap {
    height: 100%;
    overflow-y: auto;
  }
  .title {
    height: 32px;
    color: #384e8c;
    font-size: 14px;
  }
  .user-modify__form {
    .input-tips {
      display: inline-block;
      margin-left: 10px;
    }
    .form-item__input {
      width: 440px;
      height: 28px;
    }
    .area-code__selector {
      width: 70px;
      margin-right: 10px;
      /deep/ .el-input {
        min-width: 70px;
      }
      + .form-item__input {
        width: 360px;
      }
    }
  }
}
.systems-config__table {
  border-collapse: collapse;
  width: 730px;
  .has-config__btn,
  .not-config__btn {
    width: 80px;
    height: 30px;
  }
  .not-bindStatus__btn {
    background-color: #f5f5f5;
    color: #606060;
    font-size: 12px;
  }
  .has-bindStatus__btn {
    background-color: #1895dd;
    width: 80px;
    height: 30px;
  }
  .has-config__btn {
    background-color: #619b5e;
    &:hover {
      background-color: #70a06e;
    }
    &:focus {
      background-color: #5b9158;
    }
  }
  .not-config__btn {
    background-color: #4aabc6;
    &:hover {
      background-color: #5eb0c7;
    }
    &:focus {
      background-color: #46a0b9;
    }
  }
  .clear-config__btn {
    background-color: #84888c;
    padding: 1px 6px;
    width: 80px;
    height: 30px;
  }
  th,
  td {
    border: 1px solid #bccad0;
  }
  th {
    line-height: 18px;
    padding: 5px 15px;
    font-weight: bold;
    color: #3a3a3a;
  }
  td {
    padding: 10px 15px;
    color: #606060;
  }
}
.reset-pwd__btn {
  background: none;
  color: #1895dd;
  text-decoration: underline;
  margin-left: 8px;
}
.input-tips {
  margin-left: 10px;
}
.input-tipsmore {
  margin-bottom: 25px;
  margin-left: 10px;
  color: #aaa;
  display: inline-block;
}
/deep/ .el-checkbox__label{
  color: #606060;
}
.content .user-modify__form .input-tips{
  position: absolute;
}
/deep/ .margin_cls{
  margin-top:35px;
}
.input-tip{
  margin-left: 10px;
  display: inline-block;
  position: absolute;
  color: #aaa;
  word-break: break-all;
}
</style>

